import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Часовник чч:мм:сс на екрана с масите — долу в релсата с масите, точно над
// лентата с бутоните (само десктоп, `TableRail`). Отделен компонент, за да
// тиктака сам — иначе всяка секунда би ре-рендирала цялата страница.
export const TableFooterClock = () => {
  const { i18n } = useTranslation();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const locale = i18n.language?.startsWith("bg") ? "bg-BG" : "en-GB";
  const timeStr = now.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <span className="block font-pos-mono text-[26px] font-semibold leading-none tracking-tight text-pos-ink tabular-nums select-none">
      {timeStr}
    </span>
  );
};
